import BlogListItem, { BlogListItemMobile } from "./BlogListItem"

export default function BlogList({ blogs }) {
    if (!blogs) return null
    return (
        <>
            {blogs.map(blog => (
                <BlogListItem key={blog.blog_id} blog={blog} />
            ))}
        </>
    )
}

export function BlogListMobile({ blogs }) {
    if (!blogs) return null
    return (
        <>
            {blogs.map(blog => (
                <BlogListItemMobile key={blog.blog_id} blog={blog} />
            ))}
        </>
    )
}